<template>
  <div class="">
    <div class="d-flex flex-column flex-sm-row justify-space-between align-center mb-2 pl-3">
      <span class="font-weight-bold mr-2">Điểm thành phần</span>
      <v-btn v-if="canEditCourseConfig" class="elevation-0" small @click="add" color="primary" text>
        <v-icon left>add</v-icon>
        <span>Thêm</span>
      </v-btn>
      <div class="flex-fill"></div>
      <v-switch
        :disabled="!canEditCourseConfig"
        @change="onToggleRequireCondition"
        label="Môn học có điều kiện"
        v-model="requireConditionSwitchValue"
      ></v-switch>
    </div>
    <v-data-table
      disable-sort
      :headers="headers"
      :items="courseMarksSorted"
      :disable-pagination="true"
      :hide-default-footer="true"
    >
      <template v-slot:[`item.type`]="{ item }">
        {{ item.type === 'component' ? 'Điểm thành phần' : 'Điểm cuối môn' }}
      </template>
      <template v-slot:[`item.multiplier`]="{ item }">
        <v-tooltip top v-if="!hideActions">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"> {{ item.multiplier }}</span>
          </template>
          <span v-if="item.type === 'component'">
            Hệ số sử dụng khi tính điểm trung bình thành phần</span
          >
          <div class="d-flex flex-column" v-else>
            <span> Hệ số sử dụng khi tính điểm Trung bình cuối môn </span>
            <span> Điểm cuối môn chiếm {{ item.multiplier * 10 }}% điểm Trung bình cuối môn</span>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:[`item.action`]="{ item }" v-if="canEditCourseConfig">
        <div class="course-mark-table-actions">
          <v-btn small icon @click="onClickEditIcon(item)" title="Sửa">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small icon @click="onClickDeleteIcon(item)" title="Xóa">
            <v-icon small>delete</v-icon>
          </v-btn>
          <template v-if="item.type !== 'final'">
            <v-btn
              small
              icon
              @click="moveupCourseMark(item)"
              title="Di chuyển lên"
              v-if="item.index > 1"
            >
              <v-icon small>mdi-chevron-up</v-icon>
              {{ item.tableInde }}
            </v-btn>
            <v-btn
              small
              icon
              @click="movedownCourseMark(item)"
              title="Di chuyển xuống"
              v-if="item.index <= courseMarks.filter(i => i.type !== 'final').length - 1"
            >
              <v-icon small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </div>
      </template>
    </v-data-table>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.mobile"
      v-model="editCourseMarkDialog.isOpen"
      max-width="548"
    >
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>Sửa điểm</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="editCourseMarkDialog.isOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form lazy ref="form">
          <v-card-text v-if="editCourseMarkDialog.currentItem" class="pa-4">
            <v-text-field
              v-model="editCourseMarkDialog.currentItem.title"
              :rules="titleRules"
              label="Tiêu đề"
              required
              class="mb-3"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              v-model="editCourseMarkDialog.currentItem.multiplier"
              :rules="multiplierRules"
              type="number"
              label="Hệ số điểm"
              required
              hide-details="auto"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn color="primary" text @click="editCourseMarkDialog.isOpen = false">Hủy</v-btn>
            <v-btn color="primary" @click="editCourseMarkDialog.callback">Lưu</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <div class="d-flex justify-space-between mt-4 mb-2 pl-3 align-center">
      <span class="font-weight-bold mr-2">Thành tố điểm cuối môn</span>
      <div class="d-flex flex-fill align-center" v-if="canEditCourseConfig">
        <v-btn
          v-if="!!finalScore"
          color="primary"
          flat
          text
          medium
          @click="addOrUpdateCourseMarkElement()"
        >
          <v-icon left>add</v-icon>
          <span>Thêm</span>
        </v-btn>
        <div class="flex-fill"></div>
        <v-btn @click="toggleFinalScore" text :color="!finalScore ? 'primary' : 'error'" small>
          <v-icon class="mr-2">
            {{ !finalScore ? 'mdi-plus' : 'mdi-delete' }}
          </v-icon>
          {{ !finalScore ? 'Thêm điểm cuối môn' : 'Bỏ điểm cuối môn' }}
        </v-btn>
      </div>
    </div>
    <template v-if="!!finalScore">
      <v-data-table
        v-if="!!finalScore"
        disable-sort
        :headers="courseMarkElementHeaders"
        :items="courseMarkElementsSorted"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:[`item.action`]="{ item }" v-if="canEditCourseConfig">
          <v-btn small icon @click="addOrUpdateCourseMarkElement(item)" title="Sửa">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small icon @click="onClickDeleteCourseMarkElement(item)" title="Xóa">
            <v-icon small>delete</v-icon>
          </v-btn>
          <v-btn
            small
            icon
            @click="moveupCourseMarkElement(item)"
            title="Di chuyển lên"
            v-if="item.index > 1"
          >
            <v-icon small>mdi-chevron-up</v-icon>
            {{ item.tableInde }}
          </v-btn>
          <v-btn
            small
            icon
            @click="movedownCourseMarkElement(item)"
            title="Di chuyển xuống"
            v-if="item.index < courseMarkElementsSorted.length - 1"
          >
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <div v-if="totalOfCourseMarkElements" class="text-subtitle-2 px-4 py-1">
        Tổng điểm tối đa: {{ totalOfCourseMarkElements }}
      </div>
      <BaseDialog
        v-if="courseMarkElementDialog.isOpen"
        :isOpen="courseMarkElementDialog.isOpen"
        :title="courseMarkElementDialog.currentItem ? 'Thêm thành tố' : 'Sửa thành tố'"
        @close="courseMarkElementDialog.isOpen = false"
        @cancel="courseMarkElementDialog.onCancel"
        @confirm="courseMarkElementDialog.callback"
      >
        <v-form
          lazy-validation
          ref="courseMarkElementForm"
          @submit.prevent="courseMarkElementDialog.callback"
        >
          <v-card-text class="py-3 px-4">
            <v-text-field
              v-model="courseMarkElementDialog.currentItem.title"
              :rules="titleRules"
              label="Tiêu đề"
              required
              hide-details="auto"
              class="mb-3"
            ></v-text-field>
            <v-text-field
              v-model="courseMarkElementDialog.currentItem.max"
              :rules="maxRules"
              type="number"
              label="Điểm tối đa"
              required
              min="0.5"
              max="10"
              step="0.5"
              hide-details="auto"
            ></v-text-field>
          </v-card-text>
          <input type="submit" class="d-none" />
        </v-form>
      </BaseDialog>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'
import BaseDialog from '@/components/base/BaseDialog'

export default {
  components: { BaseDialog },
  data() {
    return {
      requireConditionSwitchValue: this.courseMarkConfig.requireCondition,
      // searchTeacher: '',
      courseMarkElementHeaders: [
        { text: 'Tiêu đề', value: 'title' },
        { text: 'Điểm tối đa', value: 'max' },
        { text: 'Hành động', value: 'action' }
      ],
      // gradingTeacherHeaders: [
      //   { text: 'Họ và tên', value: 'name' },
      //   { text: 'Email', value: 'email' },
      //   { text: 'Số điện thoại', value: 'phone' }
      // ],
      headers: [
        {
          text: 'Tiêu đề',
          value: 'title'
        },
        {
          text: 'Loại',
          value: 'type'
        },
        {
          text: 'Hệ số điểm',
          value: 'multiplier',
          align: 'right'
        },
        {
          text: 'Hành động',
          value: 'action',
          align: 'center'
        }
      ],
      editCourseMarkDialog: {
        valid: true,
        isOpen: false,
        currentItem: null,
        callback: () => {}
      },
      courseMarkElementDialog: {
        valid: true,
        isOpen: false,
        currentItem: null,
        callback: () => {},
        onCancel: () => {
          this.courseMarkElementDialog.isOpen = false
        }
      },

      titleRules: [this.$rules.required, this.$rules.maxLength(100)],
      multiplierRules: [this.$rules.required, this.$rules.min(1)],
      maxRules: [this.$rules.required, this.$rules.min(0.5), this.$rules.max(10)]
    }
  },
  props: {
    courseMarkConfig: Object,
    course: Object
  },
  computed: {
    ...mapState('course', ['courseMarkConfigs', 'isLoadingCourseMarkConfigs', 'courses']),
    ...mapGetters('auth', ['role']),
    canEditCourseConfig() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    },

    courseMarks() {
      if (!this.courseMarkConfig) {
        return []
      }
      return this.courseMarkConfig.course_marks
    },
    courseMarkElements() {
      if (!this.courseMarkConfig) {
        return []
      }
      return this.courseMarkConfig.course_mark_elements
    },
    courseMarksSorted() {
      return this.courseMarks.map(i => i).sort((a, b) => a.index - b.index)
    },
    courseMarkElementsSorted() {
      return this.courseMarkElements.map(i => i).sort((a, b) => a.index - b.index)
    },
    requireCondition() {
      if (!this.courseMarkConfig) {
        return false
      }
      return this.courseMarkConfig.requireCondition
    },
    totalOfCourseMarkElements() {
      if (!this.courseMarkElements || !this.courseMarkElements.length) {
        return null
      }
      return this.courseMarkElements.reduce((p, c) => {
        return p + c.max
      }, 0)
    },
    finalScore() {
      if (!this.courseMarks) {
        return
      }
      return this.courseMarks.find(i => i.type === 'final')
    }
  },
  methods: {
    ...mapActions('course', [
      'createCourseMark',
      'createCourseMarkElement',
      'updateCourseMarkElement',
      'removeCourseMarkElement',
      'removeCourseMarkConfig',
      'updateCourseMark',
      'removeCourseMark',
      'fetchCourses',
      'updateCourse',
      'fetchCourse',
      'updateCourseMarkConfig',
      'updateManyCourseMarks',
      'updateManyCourseMarkElements'
    ]),
    async moveupCourseMark(item) {
      if (!this.course.id) {
        return
      }
      const itemIndex = this.courseMarksSorted.findIndex(i => i.id === item.id)
      if (itemIndex === -1) {
        return
      }
      const itemBefore = this.courseMarksSorted[itemIndex - 1]
      if (!itemBefore) {
        return
      }
      const sourceIndex = item.index
      const destinationIndex = itemBefore.index
      try {
        await this.updateManyCourseMarks({
          id: this.courseMarkConfig.id,
          data: [
            { ...item, index: destinationIndex },
            { ...itemBefore, index: sourceIndex }
          ]
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    async movedownCourseMark(item) {
      if (!this.course.id) {
        return
      }
      const itemIndex = this.courseMarksSorted.findIndex(i => i.id === item.id)
      if (itemIndex === -1) {
        return
      }
      const itemAfter = this.courseMarksSorted[itemIndex + 1]
      if (!itemAfter) {
        return
      }
      const sourceIndex = item.index
      const destinationIndex = itemAfter.index
      try {
        await this.updateManyCourseMarks({
          id: this.courseMarkConfig.id,
          data: [
            { ...item, index: destinationIndex },
            { ...itemAfter, index: sourceIndex }
          ]
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    async moveupCourseMarkElement(item) {
      if (!this.course.id) {
        return
      }
      const itemIndex = this.courseMarkElementsSorted.findIndex(i => i.id === item.id)
      if (itemIndex === -1) {
        return
      }
      const itemBefore = this.courseMarkElementsSorted[itemIndex - 1]
      if (!itemBefore) {
        return
      }
      const sourceIndex = item.index
      const destinationIndex = itemBefore.index
      try {
        await this.updateManyCourseMarkElements({
          id: this.courseMarkConfig.id,
          data: [
            { ...item, index: destinationIndex },
            { ...itemBefore, index: sourceIndex }
          ]
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    async movedownCourseMarkElement(item) {
      if (!this.course.id) {
        return
      }
      const itemIndex = this.courseMarkElementsSorted.findIndex(i => i.id === item.id)
      if (itemIndex === -1) {
        return
      }
      const itemAfter = this.courseMarkElementsSorted[itemIndex + 1]
      if (!itemAfter) {
        return
      }
      const sourceIndex = item.index
      const destinationIndex = itemAfter.index
      try {
        await this.updateManyCourseMarkElements({
          id: this.courseMarkConfig.id,
          data: [
            { ...item, index: destinationIndex },
            { ...itemAfter, index: sourceIndex }
          ]
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    async onToggleRequireCondition(v) {
      try {
        await this.updateCourseMarkConfig({
          id: this.courseMarkConfig.id,
          data: { requireCondition: v }
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    async onClickDeleteCourseMarkElement(item) {
      this.$dialog.confirm({
        title: 'Xóa thành tố điểm',
        text: 'Xóa thành tố , và các liên kết sử dụng điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.removeCourseMarkElement({
              id: item.id,
              courseMarkConfigId: this.courseMarkConfig.id
            })
            this.$alert.success('Xóa thành tố thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          }
        }).bind(this)
      })
    },
    async addOrUpdateCourseMarkElement(item) {
      if (!this.courseMarkConfig || !this.finalScore) {
        return
      }
      this.courseMarkElementDialog.isOpen = true
      this.courseMarkElementDialog.currentItem = item
        ? _.cloneDeep(item)
        : {
            title: '',
            max: 10,
            course_mark_config: this.courseMarkConfig.id,
            course_mark: this.finalScore.id,
            course: this.course.id
          }
      this.courseMarkElementDialog.callback = (async () => {
        this.courseMarkElementDialog.valid = this.$refs.courseMarkElementForm.validate()
        if (!this.courseMarkElementDialog.valid) {
          this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
          return
        }
        try {
          if (item) {
            await this.updateCourseMarkElement({
              data: this.courseMarkElementDialog.currentItem,
              id: item.id
            })
            this.$alert.success('Cập nhật thành tố thành công')
          } else {
            await this.createCourseMarkElement({ data: this.courseMarkElementDialog.currentItem })
            this.$alert.success('Thêm thành tố thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xảy ra')
          this.fetchCourse(this.course.id)
        } finally {
          this.courseMarkElementDialog.isOpen = false
        }
      }).bind(this)
    },
    async toggleFinalScore(e) {
      if (!this.courseMarkConfig) {
        return
      }
      try {
        if (!this.finalScore) {
          await this.createCourseMark({
            data: {
              title: 'Điểm cuối môn',
              type: 'final',
              multiplier: 6,
              course_mark_config: this.courseMarkConfig.id
            }
          })
          this.$alert.success('Cập nhật thành công')
        } else {
          const finalScoreMark = this.courseMarks.find(m => m.type === 'final')
          if (!finalScoreMark) {
            return
          }
          this.$dialog.confirm({
            title: 'Bỏ điểm cuối môn',
            text: ` Bạn có chắc chắn muốn bỏ điểm cuối môn, toàn bộ dữ liệu điểm liên quan sẽ bị xóa vĩnh viễn?`,
            okText: 'Có',
            cancelText: 'Hủy',
            done: (async () => {
              await this.removeCourseMark({
                id: finalScoreMark._id,
                courseMarkConfigId: this.courseMarkConfig.id
              })
              this.$alert.success('Cập nhật thành công')
            }).bind(this)
          })
        }
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra!')
      }
    },
    getData() {
      return this.courseMarks.map(c => ({
        ...c,
        // minimum: parseInt(c.minimum),
        multiplier: parseInt(c.multiplier)
      }))
    },
    async add() {
      try {
        await this.createCourseMark({
          data: {
            title: 'Tên đầu Điểm',
            multiplier: 1,
            type: 'component',
            course_mark_config: this.courseMarkConfig.id,
            course: this.course.id
          }
        })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
      }
    },
    onClickEditIcon(item) {
      this.editCourseMarkDialog.isOpen = true
      this.editCourseMarkDialog.currentItem = _.cloneDeep(item)
      this.editCourseMarkDialog.callback = (async () => {
        this.editCourseMarkDialog.valid = this.$refs.form.validate()
        if (!this.editCourseMarkDialog.valid) {
          this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
          return
        }
        try {
          if (typeof this.editCourseMarkDialog.currentItem.multiplier === 'string') {
            this.editCourseMarkDialog.currentItem.multiplier = parseInt(
              this.editCourseMarkDialog.currentItem.multiplier
            )
          }
          // this.courseMarks = this.courseMarks.map(i =>
          //   i._id === this.editCourseMarkDialog.currentItem._id
          //     ? this.editCourseMarkDialog.currentItem
          //     : i
          // )
          const { title, multiplier } = this.editCourseMarkDialog.currentItem
          await this.updateCourseMark({
            id: this.editCourseMarkDialog.currentItem._id,
            data: { title, multiplier }
          })
          this.$alert.success('Cập nhật thành công!')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra!')
          this.fetchCourse(this.course.id)
        } finally {
          this.editCourseMarkDialog.isOpen = false
        }
      }).bind(this)
    },

    onClickDeleteIcon(item) {
      if (!this.courseMarkConfig) {
        return
      }
      this.$dialog.confirm({
        title: 'Xóa điểm',
        text: 'Xóa điểm, và các liên kết sử dụng điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: async () => {
          this.courseMarks = this.courseMarks.filter(m => m._id !== item._id)
          await this.removeCourseMark({
            id: item._id,
            courseMarkConfigId: this.courseMarkConfig.id
          })
          this.$emit('removeMark', item._id)
        }
      })
    }
  },
  watch: {
    requireCondition(v) {
      this.requireConditionSwitchValue = v
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .theme--light.v-data-table .v-data-footer {
    border: none;
  }
}
.course-mark-table-actions {
  width: 112px;
  display: inline-flex;
  align-items: center;
}
</style>
